import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { SectionTitle } from '@modules/Dashboard/Home/components/SectionTitle'

import { useOverviewContext } from '../../hooks/useOverviewContext'
import { SuggestionsSkeleton } from './SuggestionsSkeleton'
import { useSuggestions } from './hooks/useSuggestions'
import * as S from './styled'

export const Suggestions = () => {
  const overview = useOverviewContext()
  const suggestions = useSuggestions()

  if (
    overview.isLoading ||
    overview.hasAnyTier === null ||
    overview.hasWelcomePost === null ||
    overview.hasDiscordPerk === null ||
    overview.hasAnyAudioPost === null ||
    overview.hasAnyPodcast === null ||
    overview.hasTwitchSocialLink === null ||
    overview.hasTwitchMembershipsDiscount === null
  )
    return <SuggestionsSkeleton />

  if (overview.hasAnyTier === false) return null

  const getNewPostSuggestion = () => {
    if (!suggestions.newPostSuggestion.visible) return []

    return [suggestions.newPostSuggestion.suggestionProps]
  }

  const getWelcomePostSuggestion = () => {
    if (!suggestions.welcomePostSuggestion.visible) return []

    if (!overview.onboarding.active && !overview.hasWelcomePost) {
      return [suggestions.welcomePostSuggestion.suggestionProps]
    }

    return []
  }

  const getDiscordSuggestion = () => {
    if (!suggestions.discordSuggestion.visible) return []

    if (overview.hasDiscordPerk) {
      return []
    }

    return [suggestions.discordSuggestion.suggestionProps]
  }

  const getProductsSuggestion = () => {
    if (!suggestions.productsSuggestion.visible) return []

    return [suggestions.productsSuggestion.suggestionProps]
  }

  const getPromotionsSuggestion = () => {
    if (!suggestions.promotionsSuggestion.visible) return []

    return [suggestions.promotionsSuggestion.suggestionProps]
  }

  const getTwitchDiscountSuggestion = () => {
    if (!suggestions.twitchDiscountSuggestion.visible) return []

    if (overview.hasTwitchSocialLink && !overview.hasTwitchMembershipsDiscount)
      return [suggestions.twitchDiscountSuggestion.suggestionProps]

    return []
  }

  const getSpotifySuggestion = () => {
    if (!suggestions.spotifySuggestion.visible) return []

    if (!overview.hasAnyPodcast && overview.hasAnyAudioPost)
      return [suggestions.spotifySuggestion.suggestionProps]

    return []
  }

  const getSuggestions = () => {
    return [
      ...getNewPostSuggestion(),
      ...getWelcomePostSuggestion(),
      ...getDiscordSuggestion(),
      ...getProductsSuggestion(),
      ...getPromotionsSuggestion(),
      ...getTwitchDiscountSuggestion(),
      ...getSpotifySuggestion(),
    ]
  }

  return (
    <div>
      <SectionTitle title="Grow your Memberships" />
      <S.Suggestions>
        {getSuggestions().map((suggestionProps) => (
          <S.SuggestionWrapper key={suggestionProps.title}>
            <Suggestion {...suggestionProps} />
          </S.SuggestionWrapper>
        ))}
      </S.Suggestions>
    </div>
  )
}
